import React, { useEffect, useState } from 'react';
import { Grid, Paper } from '@material-ui/core';
import DashCard from '../../../app/components/DashCard';
import { useHistory } from 'react-router-dom';
import UserPageStyles from '../UserPageStyles';
import { useData } from '../../../contexts/DataContext';
import { Grain } from '@material-ui/icons';

export default function UserMain() {
  const classes = UserPageStyles();
  const history = useHistory();
  const data = useData();

  const [rainfallLogCount, setRainfallLogCount] = useState(0);
  const [gaugeDataCount, setGaugeDataCount] = useState(0);
 // const [riverScaleDataCount, setRiverScaleDataCount] = useState(0);
 // const [riverLevelLogsDataCount, setRiverLevelLogsDataCount] = useState(0);

  useEffect(() => {
    data?.refreshRainfallData();
    data?.refreshGaugeData();
    data?.refreshRiverScaleData();
    data?.refreshRiverLevelData();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    setRainfallLogCount(data?.rainfallLogsData?.length!)
  }, [data?.rainfallLogsData])

  useEffect(() => {
    setGaugeDataCount(data?.gaugeData.length!)
  }, [data?.gaugeData])

  /*useEffect(() => {
    setRiverScaleDataCount(data?.riverScaleData.length!)
  }, [data?.riverScaleData])

  useEffect(() => {
    setRiverLevelLogsDataCount(data?.riverLevelLogsData.length!)
  }, [data?.riverLevelLogsData])
*/
  return (
    <React.Fragment>
      <h2>Logs</h2>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title={<><Grain /> Rainfall Logs</>} mainText={`${rainfallLogCount}`} smallText="entries" buttonText="View All" buttonOnClick={(e) => { history.push("/u/rainfall") }} />
          </Paper>
        </Grid>
        {/*
        <Grid item xs={12} md={8} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title={<><Gradient /> Riverlevel Logs</>} mainText={`${riverLevelLogsDataCount}`} smallText="entries" buttonText="View All" buttonOnClick={(e) => { history.push("/u/riverlevel") }} />
          </Paper>
        </Grid>*/}
      </Grid>

      <h2>Managed Guages</h2>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title={<><Grain /> Rain Gauges</>} mainText={`${gaugeDataCount}`} smallText="guages" buttonText="View All" buttonOnClick={(e) => { history.push("/u/raingauge") }} />
          </Paper>
        </Grid>
        {/*
        <Grid item xs={12} md={8} lg={3}>
          <Paper className={classes.paperCard}>
            <DashCard title={<><Gradient /> River Scales</>} mainText={`${riverScaleDataCount}`} smallText="locations" buttonText="View All" buttonOnClick={(e) => { history.push("/u/riverscale") }} />
          </Paper>
        </Grid>
        */}
      </Grid>
    </React.Fragment >
  );
}

